module.exports = __webpack_public_path__ + "static/media/ally_pro_web_9.e04ab9d5.jpg";